import { createReducer, on } from '@ngrx/store';
import { withEntityReducer } from '@aston/foundation';
import { NewAccountStep } from 'apps/console/src/app/account-module/enums';

import { initialState, INewAccountState } from './state';
import * as featureActions from './actions';

// declare our fully typed reducer
export const NewAccountStoreReducer = createReducer(
	initialState,

	...withEntityReducer<INewAccountState>('subsidiaryForm', featureActions.SubsidiaryFormActions),
	...withEntityReducer<INewAccountState>('subsidiaryForm', featureActions.SubsidiaryBlockedFormActions),
	...withEntityReducer<INewAccountState>('subsidiaryFromLegalIdentifier', featureActions.SubsidiaryFromLegalIdentifierActions),
	...withEntityReducer<INewAccountState>('subscriptionForm', featureActions.SubscriptionFormActions),

	on(featureActions.LoadSubsidiaryFromLegalIdentifierRequest, state => ({
		...state,
		subsidiaryForm: {
			...state.subsidiaryForm,
			error: null
		},
		subsidiaryBlockedForm: {
			...state.subsidiaryBlockedForm,
			error: null
		}
	})),

	on(featureActions.SubmitSubsidiaryFormFailure, state => ({
		...state,
		selectedSubsidiary: {
			...state.selectedSubsidiary,
			isLoading: false,
		}
	})),

	on(featureActions.SubmitSubsidiaryFormRequest, state => ({
		...state,
		subsidiaryFromLegalIdentifier: {
			...state.subsidiaryFromLegalIdentifier,
			error: null
		},
		subsidiaryBlockedForm: {
			...state.subsidiaryBlockedForm,
			error: null
		},
		selectedSubsidiary: {
			...state.selectedSubsidiary,
			isLoading: true,
			entity: null
		}
	})),

	on(featureActions.CancelCreation, state => ({
		...state,
		creationCanceled: true,
	})),

	on(featureActions.SetCurrentStep, (state, action) => ({
		...state,
		currentStep: action.param
	})),

	on(featureActions.SubsidiaryInitializedChanged, state => ({
		...state,
		currentStep: NewAccountStep.Validation,
		isSubsidiaryInitialized: true
	})),
	on(featureActions.SubsidiaryNotInitializedChanged, state => ({
		...state,
		isSubsidiaryInitialized: false
	})),
	on(featureActions.SubmitSubsidiaryFormSuccess, state => ({
		...state,
		currentStep: NewAccountStep.Validation,
		subsidiaryFromLegalIdentifier: {
			...state.subsidiaryFromLegalIdentifier,
			entity: null
		}
	})),

	on(featureActions.SetCurrentSubsidiary, (state, action) => ({
		...state,
		currentStep: NewAccountStep.Validation,
		selectedSubsidiary: {
			...state.selectedSubsidiary,
			entity: {
				...state.selectedSubsidiary.entity,
				subsidiaryId: action.subsidiaryId
			}
		}
	})),

	on(featureActions.SetSelectedSubsidiary, (state, action) => ({
		...state,
		selectedSubsidiary: {
			...state.selectedSubsidiary,
			entity: action.subsidiary
		}
	})),

	on(featureActions.SubmitSubsidiaryBlockedFormRequest, state => ({
		...state,
		// We have to stop regular form loading
		subsidiaryForm: {
			...state.subsidiaryForm,
			isLoading: false,
			error: null
		}
	})),
);
